export default {
  "countryList": [
    {
      "code": "af",
      "enName": "AFGHANISTAN",
      "cnName": "阿富汗",
      "dialingCode": "+93",
      "numberCode": "4",
      "showName": "阿富汗(AFGHANISTAN)"
    },
    {
      "code": "al",
      "enName": "ALBANIA",
      "cnName": "阿尔巴尼亚",
      "dialingCode": "+355",
      "numberCode": "8",
      "showName": "阿尔巴尼亚(ALBANIA)"
    },
    {
      "code": "dz",
      "enName": "ALGERIA",
      "cnName": "阿尔及利亚",
      "dialingCode": "+213",
      "numberCode": "12",
      "showName": "阿尔及利亚(ALGERIA)"
    },
    {
      "code": "as",
      "enName": "AMERICAN SAMOA",
      "cnName": "美属萨摩亚",
      "dialingCode": "+684",
      "numberCode": "16",
      "showName": "美属萨摩亚(AMERICAN SAMOA)"
    },
    {
      "code": "ad",
      "enName": "ANDORRA",
      "cnName": "安道尔",
      "dialingCode": "+376",
      "numberCode": "20",
      "showName": "安道尔(ANDORRA)"
    },
    {
      "code": "ao",
      "enName": "ANGOLA",
      "cnName": "安哥拉",
      "dialingCode": "+244",
      "numberCode": "24",
      "showName": "安哥拉(ANGOLA)"
    },
    {
      "code": "ai",
      "enName": "ANGUILLA",
      "cnName": "安圭拉岛",
      "dialingCode": "+1264",
      "numberCode": "660",
      "showName": "安圭拉岛(ANGUILLA)"
    },
    {
      "code": "ag",
      "enName": "ANTIGUA AND BARBUDA",
      "cnName": "安提瓜和巴布达",
      "dialingCode": "+1268",
      "numberCode": "28",
      "showName": "安提瓜和巴布达(ANTIGUA AND BARBUDA)"
    },
    {
      "code": "ar",
      "enName": "ARGENTINA",
      "cnName": "阿根廷",
      "dialingCode": "+54",
      "numberCode": "32",
      "showName": "阿根廷(ARGENTINA)"
    },
    {
      "code": "am",
      "enName": "ARMENIA",
      "cnName": "亚美尼亚",
      "dialingCode": "+374",
      "numberCode": "51",
      "showName": "亚美尼亚(ARMENIA)"
    },
    {
      "code": "au",
      "enName": "AUSTRALIA",
      "cnName": "澳大利亚",
      "dialingCode": "+61",
      "numberCode": "36",
      "showName": "澳大利亚(AUSTRALIA)"
    },
    {
      "code": "at",
      "enName": "AUSTRIA",
      "cnName": "奥地利",
      "dialingCode": "+43",
      "numberCode": "40",
      "showName": "奥地利(AUSTRIA)"
    },
    {
      "code": "az",
      "enName": "AZERBAIJAN",
      "cnName": "阿塞拜疆",
      "dialingCode": "+994",
      "numberCode": "31",
      "showName": "阿塞拜疆(AZERBAIJAN)"
    },
    {
      "code": "bs",
      "enName": "BAHAMAS",
      "cnName": "巴哈马",
      "dialingCode": "+1242",
      "numberCode": "44",
      "showName": "巴哈马(BAHAMAS)"
    },
    {
      "code": "bh",
      "enName": "BAHRAIN",
      "cnName": "巴林",
      "dialingCode": "+973",
      "numberCode": "48",
      "showName": "巴林(BAHRAIN)"
    },
    {
      "code": "bd",
      "enName": "BANGLADESH",
      "cnName": "孟加拉国",
      "dialingCode": "+880",
      "numberCode": "50",
      "showName": "孟加拉国(BANGLADESH)"
    },
    {
      "code": "bb",
      "enName": "BARBADOS",
      "cnName": "巴巴多斯",
      "dialingCode": "+1246",
      "numberCode": "52",
      "showName": "巴巴多斯(BARBADOS)"
    },
    {
      "code": "by",
      "enName": "BELARUS",
      "cnName": "白俄罗斯",
      "dialingCode": "+375",
      "numberCode": "112",
      "showName": "白俄罗斯(BELARUS)"
    },
    {
      "code": "be",
      "enName": "BELGIUM",
      "cnName": "比利时",
      "dialingCode": "+32",
      "numberCode": "56",
      "showName": "比利时(BELGIUM)"
    },
    {
      "code": "bz",
      "enName": "BELIZE",
      "cnName": "伯利兹",
      "dialingCode": "+501",
      "numberCode": "84",
      "showName": "伯利兹(BELIZE)"
    },
    {
      "code": "bj",
      "enName": "BENIN",
      "cnName": "贝宁",
      "dialingCode": "+229",
      "numberCode": "204",
      "showName": "贝宁(BENIN)"
    },
    {
      "code": "bm",
      "enName": "BERMUDA",
      "cnName": "百慕大群岛",
      "dialingCode": "+1441",
      "numberCode": "60",
      "showName": "百慕大群岛(BERMUDA)"
    },
    {
      "code": "bo",
      "enName": "BOLIVIA, PLURINATIONAL STATE OF",
      "cnName": "玻利维亚",
      "dialingCode": "+591",
      "numberCode": "68",
      "showName": "玻利维亚(BOLIVIA, PLURINATIONAL STATE OF)"
    },
    {
      "code": "bw",
      "enName": "BOTSWANA",
      "cnName": "博茨瓦纳",
      "dialingCode": "+267",
      "numberCode": "72",
      "showName": "博茨瓦纳(BOTSWANA)"
    },
    {
      "code": "br",
      "enName": "BRAZIL",
      "cnName": "巴西",
      "dialingCode": "+55",
      "numberCode": "76",
      "showName": "巴西(BRAZIL)"
    },
    {
      "code": "bn",
      "enName": "BRUNEI DARUSSALAM",
      "cnName": "文莱",
      "dialingCode": "+673",
      "numberCode": "96",
      "showName": "文莱(BRUNEI DARUSSALAM)"
    },
    {
      "code": "bg",
      "enName": "BULGARIA",
      "cnName": "保加利亚",
      "dialingCode": "+359",
      "numberCode": "100",
      "showName": "保加利亚(BULGARIA)"
    },
    {
      "code": "bf",
      "enName": "BURKINA FASO",
      "cnName": "布基纳法索",
      "dialingCode": "+226",
      "numberCode": "854",
      "showName": "布基纳法索(BURKINA FASO)"
    },
    {
      "code": "bi",
      "enName": "BURUNDI",
      "cnName": "布隆迪",
      "dialingCode": "+257",
      "numberCode": "108",
      "showName": "布隆迪(BURUNDI)"
    },
    {
      "code": "kh",
      "enName": "CAMBODIA",
      "cnName": "柬埔寨",
      "dialingCode": "+855",
      "numberCode": "116",
      "showName": "柬埔寨(CAMBODIA)"
    },
    {
      "code": "cm",
      "enName": "CAMEROON",
      "cnName": "喀麦隆",
      "dialingCode": "+237",
      "numberCode": "120",
      "showName": "喀麦隆(CAMEROON)"
    },
    {
      "code": "ca",
      "enName": "CANADA",
      "cnName": "加拿大",
      "dialingCode": "+1",
      "numberCode": "124",
      "showName": "加拿大(CANADA)"
    },
    {
      "code": "ky",
      "enName": "CAYMAN ISLANDS",
      "cnName": "开曼群岛",
      "dialingCode": "+1345",
      "numberCode": "136",
      "showName": "开曼群岛(CAYMAN ISLANDS)"
    },
    {
      "code": "cf",
      "enName": "CENTRAL AFRICAN REPUBLIC",
      "cnName": "中非共和国",
      "dialingCode": "+236",
      "numberCode": "140",
      "showName": "中非共和国(CENTRAL AFRICAN REPUBLIC)"
    },
    {
      "code": "td",
      "enName": "CHAD",
      "cnName": "乍得",
      "dialingCode": "+235",
      "numberCode": "148",
      "showName": "乍得(CHAD)"
    },
    {
      "code": "cl",
      "enName": "CHILE",
      "cnName": "智利",
      "dialingCode": "+56",
      "numberCode": "152",
      "showName": "智利(CHILE)"
    },
    {
      "code": "cn",
      "enName": "CHINA",
      "cnName": "中国",
      "dialingCode": "+86",
      "numberCode": "156",
      "showName": "中国(CHINA)"
    },
    {
      "code": "co",
      "enName": "COLOMBIA",
      "cnName": "哥伦比亚",
      "dialingCode": "+57",
      "numberCode": "170",
      "showName": "哥伦比亚(COLOMBIA)"
    },
    {
      "code": "cg",
      "enName": "CONGO",
      "cnName": "刚果",
      "dialingCode": "+242",
      "numberCode": "178",
      "showName": "刚果(CONGO)"
    },
    {
      "code": "ck",
      "enName": "COOK ISLANDS",
      "cnName": "库克群岛",
      "dialingCode": "+682",
      "numberCode": "184",
      "showName": "库克群岛(COOK ISLANDS)"
    },
    {
      "code": "cr",
      "enName": "COSTA RICA",
      "cnName": "哥斯达黎加",
      "dialingCode": "+506",
      "numberCode": "188",
      "showName": "哥斯达黎加(COSTA RICA)"
    },
    {
      "code": "ci",
      "enName": "CÔTE D'IVOIRE",
      "cnName": "科特迪瓦",
      "dialingCode": "+225",
      "numberCode": "384",
      "showName": "科特迪瓦(CÔTE D'IVOIRE)"
    },
    {
      "code": "hr",
      "enName": "CROATIA",
      "cnName": "克罗地亚",
      "dialingCode": "+385",
      "numberCode": "191",
      "showName": "克罗地亚(HR)"
    },
    {
      "code": "cu",
      "enName": "CUBA",
      "cnName": "古巴",
      "dialingCode": "+53",
      "numberCode": "192",
      "showName": "古巴(CUBA)"
    },
    {
      "code": "cy",
      "enName": "CYPRUS",
      "cnName": "塞浦路斯",
      "dialingCode": "+357",
      "numberCode": "196",
      "showName": "塞浦路斯(CYPRUS)"
    },
    {
      "code": "cz",
      "enName": "CZECH REPUBLIC",
      "cnName": "捷克共和国",
      "dialingCode": "+420",
      "numberCode": "203",
      "showName": "捷克共和国(CZECH REPUBLIC)"
    },
    {
      "code": "dk",
      "enName": "DENMARK",
      "cnName": "丹麦",
      "dialingCode": "+45",
      "numberCode": "208",
      "showName": "丹麦(DENMARK)"
    },
    {
      "code": "dj",
      "enName": "DJIBOUTI",
      "cnName": "吉布提",
      "dialingCode": "+253",
      "numberCode": "262",
      "showName": "吉布提(DJIBOUTI)"
    },
    {
      "code": "do",
      "enName": "DOMINICAN REPUBLIC",
      "cnName": "多米尼加共和国",
      "dialingCode": "+1890",
      "numberCode": "214",
      "showName": "多米尼加共和国(DOMINICAN REPUBLIC)"
    },
    {
      "code": "ec",
      "enName": "ECUADOR",
      "cnName": "厄瓜多尔",
      "dialingCode": "+593",
      "numberCode": "218",
      "showName": "厄瓜多尔(ECUADOR)"
    },
    {
      "code": "eg",
      "enName": "EGYPT",
      "cnName": "埃及",
      "dialingCode": "+20",
      "numberCode": "818",
      "showName": "埃及(EGYPT)"
    },
    {
      "code": "sv",
      "enName": "EL SALVADOR",
      "cnName": "萨尔瓦多",
      "dialingCode": "+503",
      "numberCode": "222",
      "showName": "萨尔瓦多(EL SALVADOR)"
    },
    {
      "code": "ee",
      "enName": "ESTONIA",
      "cnName": "爱沙尼亚",
      "dialingCode": "+372",
      "numberCode": "233",
      "showName": "爱沙尼亚(ESTONIA)"
    },
    {
      "code": "et",
      "enName": "ETHIOPIA",
      "cnName": "埃塞俄比亚",
      "dialingCode": "+251",
      "numberCode": "231",
      "showName": "埃塞俄比亚(ETHIOPIA)"
    },
    {
      "code": "fj",
      "enName": "FIJI",
      "cnName": "斐济群岛",
      "dialingCode": "+679",
      "numberCode": "242",
      "showName": "斐济群岛(FIJI)"
    },
    {
      "code": "fi",
      "enName": "FINLAND",
      "cnName": "芬兰",
      "dialingCode": "+358",
      "numberCode": "246",
      "showName": "芬兰(FINLAND)"
    },
    {
      "code": "fr",
      "enName": "FRANCE",
      "cnName": "法国",
      "dialingCode": "+33",
      "numberCode": "250",
      "showName": "法国(FRANCE)"
    },
    {
      "code": "gf",
      "enName": "FRENCH GUIANA",
      "cnName": "法属圭亚那",
      "dialingCode": "+594",
      "numberCode": "254",
      "showName": "法属圭亚那(FRENCH GUIANA)"
    },
    {
      "code": "pf",
      "enName": "FRENCH POLYNESIA",
      "cnName": "法属波利尼西亚",
      "dialingCode": "+689",
      "numberCode": "258",
      "showName": "法属波利尼西亚(FRENCH POLYNESIA)"
    },
    {
      "code": "ga",
      "enName": "GABON",
      "cnName": "加蓬",
      "dialingCode": "+241",
      "numberCode": "266",
      "showName": "加蓬(GABON)"
    },
    {
      "code": "gm",
      "enName": "GAMBIA",
      "cnName": "冈比亚",
      "dialingCode": "+220",
      "numberCode": "270",
      "showName": "冈比亚(GAMBIA)"
    },
    {
      "code": "ge",
      "enName": "GEORGIA",
      "cnName": "乔治亚",
      "dialingCode": "+995",
      "numberCode": "268",
      "showName": "乔治亚(GEORGIA)"
    },
    {
      "code": "de",
      "enName": "GERMANY",
      "cnName": "德国",
      "dialingCode": "+49",
      "numberCode": "276",
      "showName": "德国(GERMANY)"
    },
    {
      "code": "gh",
      "enName": "GHANA",
      "cnName": "加纳",
      "dialingCode": "+233",
      "numberCode": "288",
      "showName": "加纳(GHANA)"
    },
    {
      "code": "gi",
      "enName": "GIBRALTAR",
      "cnName": "直布罗陀",
      "dialingCode": "+350",
      "numberCode": "292",
      "showName": "直布罗陀(GIBRALTAR)"
    },
    {
      "code": "gr",
      "enName": "GREECE",
      "cnName": "希腊",
      "dialingCode": "+30",
      "numberCode": "300",
      "showName": "希腊(GREECE)"
    },
    {
      "code": "gd",
      "enName": "GRENADA",
      "cnName": "格林纳达",
      "dialingCode": "+1809",
      "numberCode": "308",
      "showName": "格林纳达(GRENADA)"
    },
    {
      "code": "gu",
      "enName": "GUAM",
      "cnName": "关岛",
      "dialingCode": "+1671",
      "numberCode": "316",
      "showName": "关岛(GUAM)"
    },
    {
      "code": "gt",
      "enName": "GUATEMALA",
      "cnName": "危地马拉",
      "dialingCode": "+502",
      "numberCode": "320",
      "showName": "危地马拉(GUATEMALA)"
    },
    {
      "code": "gn",
      "enName": "GUINEA",
      "cnName": "几内亚",
      "dialingCode": "+224",
      "numberCode": "324",
      "showName": "几内亚(GUINEA)"
    },
    {
      "code": "gy",
      "enName": "GUYANA",
      "cnName": "圭亚那",
      "dialingCode": "+592",
      "numberCode": "328",
      "showName": "圭亚那(GUYANA)"
    },
    {
      "code": "ht",
      "enName": "HAITI",
      "cnName": "海地",
      "dialingCode": "+509",
      "numberCode": "332",
      "showName": "海地(HAITI)"
    },
    {
      "code": "hn",
      "enName": "HONDURAS",
      "cnName": "洪都拉斯",
      "dialingCode": "+504",
      "numberCode": "340",
      "showName": "洪都拉斯(HONDURAS)"
    },
    {
      "code": "hk",
      "enName": "HONG KONG",
      "cnName": "香港",
      "dialingCode": "+852",
      "numberCode": "344",
      "showName": "香港(HONG KONG)"
    },
    {
      "code": "hu",
      "enName": "HUNGARY",
      "cnName": "匈牙利",
      "dialingCode": "+36",
      "numberCode": "348",
      "showName": "匈牙利(HUNGARY)"
    },
    {
      "code": "is",
      "enName": "ICELAND",
      "cnName": "冰岛",
      "dialingCode": "+354",
      "numberCode": "352",
      "showName": "冰岛(ICELAND)"
    },
    {
      "code": "in",
      "enName": "INDIA",
      "cnName": "印度",
      "dialingCode": "+91",
      "numberCode": "356",
      "showName": "印度(INDIA)"
    },
    {
      "code": "id",
      "enName": "INDONESIA",
      "cnName": "印度尼西亚",
      "dialingCode": "+62",
      "numberCode": "360",
      "showName": "印度尼西亚(INDONESIA)"
    },
    {
      "code": "ir",
      "enName": "IRAN, ISLAMIC REPUBLIC OF",
      "cnName": "伊朗",
      "dialingCode": "+98",
      "numberCode": "364",
      "showName": "伊朗(IRAN, ISLAMIC REPUBLIC OF)"
    },
    {
      "code": "iq",
      "enName": "IRAQ",
      "cnName": "伊拉克",
      "dialingCode": "+964",
      "numberCode": "368",
      "showName": "伊拉克(IRAQ)"
    },
    {
      "code": "ie",
      "enName": "IRELAND",
      "cnName": "爱尔兰",
      "dialingCode": "+353",
      "numberCode": "372",
      "showName": "爱尔兰(IRELAND)"
    },
    {
      "code": "il",
      "enName": "ISRAEL",
      "cnName": "以色列",
      "dialingCode": "+972",
      "numberCode": "376",
      "showName": "以色列(ISRAEL)"
    },
    {
      "code": "it",
      "enName": "ITALY",
      "cnName": "意大利",
      "dialingCode": "+39",
      "numberCode": "380",
      "showName": "意大利(ITALY)"
    },
    {
      "code": "jm",
      "enName": "JAMAICA",
      "cnName": "牙买加",
      "dialingCode": "+1876",
      "numberCode": "388",
      "showName": "牙买加(JAMAICA)"
    },
    {
      "code": "jp",
      "enName": "JAPAN",
      "cnName": "日本",
      "dialingCode": "+81",
      "numberCode": "392",
      "showName": "日本(JAPAN)"
    },
    {
      "code": "jo",
      "enName": "JORDAN",
      "cnName": "约旦",
      "dialingCode": "+962",
      "numberCode": "400",
      "showName": "约旦(JORDAN)"
    },
    {
      "code": "kz",
      "enName": "KAZAKHSTAN",
      "cnName": "哈萨克斯坦",
      "dialingCode": "+7",
      "numberCode": "398",
      "showName": "哈萨克斯坦(KAZAKHSTAN)"
    },
    {
      "code": "ke",
      "enName": "KENYA",
      "cnName": "肯尼亚",
      "dialingCode": "+254",
      "numberCode": "404",
      "showName": "肯尼亚(KENYA)"
    },
    {
      "code": "kp",
      "enName": "KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF",
      "cnName": "朝鲜",
      "dialingCode": "+850",
      "numberCode": "408",
      "showName": "朝鲜(KOREA, DEMOCRATIC PEOPLE'S REPUBLIC OF)"
    },
    {
      "code": "kr",
      "enName": "KOREA, REPUBLIC OF",
      "cnName": "韩国",
      "dialingCode": "+82",
      "numberCode": "410",
      "showName": "韩国(KOREA, REPUBLIC OF)"
    },
    {
      "code": "kw",
      "enName": "KUWAIT",
      "cnName": "科威特",
      "dialingCode": "+965",
      "numberCode": "414",
      "showName": "科威特(KUWAIT)"
    },
    {
      "code": "kg",
      "enName": "KYRGYZSTAN",
      "cnName": "吉尔吉斯斯坦",
      "dialingCode": "+331",
      "numberCode": "417",
      "showName": "吉尔吉斯斯坦(KYRGYZSTAN)"
    },
    {
      "code": "la",
      "enName": "LAO PEOPLE'S DEMOCRATIC REPUBLIC",
      "cnName": "老挝",
      "dialingCode": "+856",
      "numberCode": "418",
      "showName": "老挝(LAO PEOPLE'S DEMOCRATIC REPUBLIC)"
    },
    {
      "code": "lv",
      "enName": "LATVIA",
      "cnName": "拉脱维亚",
      "dialingCode": "+371",
      "numberCode": "428",
      "showName": "拉脱维亚(LATVIA)"
    },
    {
      "code": "lb",
      "enName": "LEBANON",
      "cnName": "黎巴嫩",
      "dialingCode": "+961",
      "numberCode": "422",
      "showName": "黎巴嫩(LEBANON)"
    },
    {
      "code": "ls",
      "enName": "LESOTHO",
      "cnName": "莱索托",
      "dialingCode": "+266",
      "numberCode": "426",
      "showName": "莱索托(LESOTHO)"
    },
    {
      "code": "lr",
      "enName": "LIBERIA",
      "cnName": "利比里亚",
      "dialingCode": "+231",
      "numberCode": "430",
      "showName": "利比里亚(LIBERIA)"
    },
    {
      "code": "ly",
      "enName": "LIBYAN ARAB JAMAHIRIYA",
      "cnName": "利比亚",
      "dialingCode": "+218",
      "numberCode": "434",
      "showName": "利比亚(LIBYAN ARAB JAMAHIRIYA)"
    },
    {
      "code": "li",
      "enName": "LIECHTENSTEIN",
      "cnName": "列支敦士登",
      "dialingCode": "+423",
      "numberCode": "438",
      "showName": "列支敦士登(LIECHTENSTEIN)"
    },
    {
      "code": "lt",
      "enName": "LITHUANIA",
      "cnName": "立陶宛",
      "dialingCode": "+370",
      "numberCode": "440",
      "showName": "立陶宛(LITHUANIA)"
    },
    {
      "code": "lu",
      "enName": "LUXEMBOURG",
      "cnName": "卢森堡",
      "dialingCode": "+352",
      "numberCode": "442",
      "showName": "卢森堡(LUXEMBOURG)"
    },
    {
      "code": "mo",
      "enName": "MACAO",
      "cnName": "澳门",
      "dialingCode": "+853",
      "numberCode": "446",
      "showName": "澳门(MACAO)"
    },
    {
      "code": "mg",
      "enName": "MADAGASCAR",
      "cnName": "马达加斯加",
      "dialingCode": "+261",
      "numberCode": "450",
      "showName": "马达加斯加(MADAGASCAR)"
    },
    {
      "code": "mw",
      "enName": "MALAWI",
      "cnName": "马拉维",
      "dialingCode": "+265",
      "numberCode": "454",
      "showName": "马拉维(MALAWI)"
    },
    {
      "code": "my",
      "enName": "MALAYSIA",
      "cnName": "马来西亚",
      "dialingCode": "+60",
      "numberCode": "458",
      "showName": "马来西亚(MALAYSIA)"
    },
    {
      "code": "mv",
      "enName": "MALDIVES",
      "cnName": "马尔代夫",
      "dialingCode": "+960",
      "numberCode": "462",
      "showName": "马尔代夫(MALDIVES)"
    },
    {
      "code": "ml",
      "enName": "MALI",
      "cnName": "马里",
      "dialingCode": "+223",
      "numberCode": "466",
      "showName": "马里(MALI)"
    },
    {
      "code": "mt",
      "enName": "MALTA",
      "cnName": "马耳他",
      "dialingCode": "+356",
      "numberCode": "470",
      "showName": "马耳他(MALTA)"
    },
    {
      "code": "mq",
      "enName": "MARTINIQUE",
      "cnName": "马提尼克岛",
      "dialingCode": "+596",
      "numberCode": "474",
      "showName": "马提尼克岛(MARTINIQUE)"
    },
    {
      "code": "mu",
      "enName": "MAURITIUS",
      "cnName": "毛里求斯",
      "dialingCode": "+230",
      "numberCode": "480",
      "showName": "毛里求斯(MAURITIUS)"
    },
    {
      "code": "mx",
      "enName": "MEXICO",
      "cnName": "墨西哥",
      "dialingCode": "+52",
      "numberCode": "484",
      "showName": "墨西哥(MEXICO)"
    },
    {
      "code": "md",
      "enName": "MOLDOVA, REPUBLIC OF",
      "cnName": "摩尔多瓦",
      "dialingCode": "+373",
      "numberCode": "498",
      "showName": "摩尔多瓦(MOLDOVA, REPUBLIC OF)"
    },
    {
      "code": "mc",
      "enName": "MONACO",
      "cnName": "摩纳哥",
      "dialingCode": "+377",
      "numberCode": "492",
      "showName": "摩纳哥(MONACO)"
    },
    {
      "code": "mn",
      "enName": "MONGOLIA",
      "cnName": "蒙古",
      "dialingCode": "+976",
      "numberCode": "496",
      "showName": "蒙古(MONGOLIA)"
    },
    {
      "code": "ms",
      "enName": "MONTSERRAT",
      "cnName": "蒙特塞拉特",
      "dialingCode": "+1664",
      "numberCode": "500",
      "showName": "蒙特塞拉特(MONTSERRAT)"
    },
    {
      "code": "ma",
      "enName": "MOROCCO",
      "cnName": "摩洛哥",
      "dialingCode": "+212",
      "numberCode": "504",
      "showName": "摩洛哥(MOROCCO)"
    },
    {
      "code": "mz",
      "enName": "MOZAMBIQUE",
      "cnName": "莫桑比克",
      "dialingCode": "+258",
      "numberCode": "508",
      "showName": "莫桑比克(MOZAMBIQUE)"
    },
    {
      "code": "mm",
      "enName": "MYANMAR",
      "cnName": "缅甸",
      "dialingCode": "+95",
      "numberCode": "104",
      "showName": "缅甸(MYANMAR)"
    },
    {
      "code": "na",
      "enName": "NAMIBIA",
      "cnName": "纳米比亚",
      "dialingCode": "+264",
      "numberCode": "516",
      "showName": "纳米比亚(NAMIBIA)"
    },
    {
      "code": "nr",
      "enName": "NAURU",
      "cnName": "瑙鲁",
      "dialingCode": "+674",
      "numberCode": "520",
      "showName": "瑙鲁(NAURU)"
    },
    {
      "code": "np",
      "enName": "NEPAL",
      "cnName": "尼泊尔",
      "dialingCode": "+977",
      "numberCode": "524",
      "showName": "尼泊尔(NEPAL)"
    },
    {
      "code": "nl",
      "enName": "NETHERLANDS",
      "cnName": "荷兰",
      "dialingCode": "+31",
      "numberCode": "528",
      "showName": "荷兰(NETHERLANDS)"
    },
    {
      "code": "an",
      "enName": "NETHERLANDS ANTILLES",
      "cnName": "荷属安的列斯群岛",
      "dialingCode": "+599",
      "numberCode": "530",
      "showName": "荷属安的列斯群岛(NETHERLANDS ANTILLES)"
    },
    {
      "code": "nz",
      "enName": "NEW ZEALAND",
      "cnName": "新西兰",
      "dialingCode": "+64",
      "numberCode": "554",
      "showName": "新西兰(NEW ZEALAND)"
    },
    {
      "code": "ni",
      "enName": "NICARAGUA",
      "cnName": "尼加拉瓜",
      "dialingCode": "+505",
      "numberCode": "558",
      "showName": "尼加拉瓜(NICARAGUA)"
    },
    {
      "code": "ne",
      "enName": "NIGER",
      "cnName": "尼日尔",
      "dialingCode": "+227",
      "numberCode": "562",
      "showName": "尼日尔(NIGER)"
    },
    {
      "code": "ng",
      "enName": "NIGERIA",
      "cnName": "尼日利亚",
      "dialingCode": "+234",
      "numberCode": "566",
      "showName": "尼日利亚(NIGERIA)"
    },
    {
      "code": "no",
      "enName": "NORWAY",
      "cnName": "挪威",
      "dialingCode": "+47",
      "numberCode": "578",
      "showName": "挪威(NORWAY)"
    },
    {
      "code": "om",
      "enName": "OMAN",
      "cnName": "阿曼",
      "dialingCode": "+968",
      "numberCode": "512",
      "showName": "阿曼(OMAN)"
    },
    {
      "code": "pk",
      "enName": "PAKISTAN",
      "cnName": "巴基斯坦",
      "dialingCode": "+92",
      "numberCode": "586",
      "showName": "巴基斯坦(PAKISTAN)"
    },
    {
      "code": "pa",
      "enName": "PANAMA",
      "cnName": "巴拿马",
      "dialingCode": "+507",
      "numberCode": "591",
      "showName": "巴拿马(PANAMA)"
    },
    {
      "code": "pg",
      "enName": "PAPUA NEW GUINEA",
      "cnName": "巴布亚新几内亚",
      "dialingCode": "+675",
      "numberCode": "598",
      "showName": "巴布亚新几内亚(PAPUA NEW GUINEA)"
    },
    {
      "code": "py",
      "enName": "PARAGUAY",
      "cnName": "巴拉圭",
      "dialingCode": "+595",
      "numberCode": "600",
      "showName": "巴拉圭(PARAGUAY)"
    },
    {
      "code": "pe",
      "enName": "PERU",
      "cnName": "秘鲁",
      "dialingCode": "+51",
      "numberCode": "604",
      "showName": "秘鲁(PERU)"
    },
    {
      "code": "ph",
      "enName": "PHILIPPINES",
      "cnName": "菲律宾",
      "dialingCode": "+63",
      "numberCode": "608",
      "showName": "菲律宾(PHILIPPINES)"
    },
    {
      "code": "pl",
      "enName": "POLAND",
      "cnName": "波兰",
      "dialingCode": "+48",
      "numberCode": "616",
      "showName": "波兰(POLAND)"
    },
    {
      "code": "pt",
      "enName": "PORTUGAL",
      "cnName": "葡萄牙",
      "dialingCode": "+351",
      "numberCode": "620",
      "showName": "葡萄牙(PORTUGAL)"
    },
    {
      "code": "pr",
      "enName": "PUERTO RICO",
      "cnName": "波多黎各",
      "dialingCode": "+1787",
      "numberCode": "630",
      "showName": "波多黎各(PUERTO RICO)"
    },
    {
      "code": "qa",
      "enName": "QATAR",
      "cnName": "卡塔尔",
      "dialingCode": "+974",
      "numberCode": "634",
      "showName": "卡塔尔(QATAR)"
    },
    {
      "code": "re",
      "enName": "REUNION",
      "cnName": "留尼汪岛",
      "dialingCode": "+262",
      "numberCode": "638",
      "showName": "留尼汪岛(REUNION)"
    },
    {
      "code": "ro",
      "enName": "ROMANIA",
      "cnName": "罗马尼亚",
      "dialingCode": "+40",
      "numberCode": "642",
      "showName": "罗马尼亚(ROMANIA)"
    },
    {
      "code": "ru",
      "enName": "RUSSIAN FEDERATION",
      "cnName": "俄罗斯",
      "dialingCode": "+7",
      "numberCode": "643",
      "showName": "俄罗斯(RUSSIAN FEDERATION)"
    },
    {
      "code": "lc",
      "enName": "SAINT LUCIA",
      "cnName": "圣卢西亚",
      "dialingCode": "+1758",
      "numberCode": "662",
      "showName": "圣卢西亚(SAINT LUCIA)"
    },
    {
      "code": "vc",
      "enName": "SAINT VINCENT AND THE GRENADINES",
      "cnName": "圣文森特和格林纳丁斯",
      "dialingCode": "+1784",
      "numberCode": "670",
      "showName": "圣文森特和格林纳丁斯(SAINT VINCENT AND THE GRENADINES)"
    },
    {
      "code": "ws",
      "enName": "SAMOA",
      "cnName": "萨摩亚",
      "dialingCode": "+685",
      "numberCode": "882",
      "showName": "萨摩亚(SAMOA)"
    },
    {
      "code": "sm",
      "enName": "SAN MARINO",
      "cnName": "圣马力诺",
      "dialingCode": "+378",
      "numberCode": "674",
      "showName": "圣马力诺(SAN MARINO)"
    },
    {
      "code": "st",
      "enName": "SAO TOME AND PRINCIPE",
      "cnName": "圣多美和普林西比",
      "dialingCode": "+239",
      "numberCode": "678",
      "showName": "圣多美和普林西比(SAO TOME AND PRINCIPE)"
    },
    {
      "code": "sa",
      "enName": "SAUDI ARABIA",
      "cnName": "沙特阿拉伯",
      "dialingCode": "+966",
      "numberCode": "682",
      "showName": "沙特阿拉伯(SAUDI ARABIA)"
    },
    {
      "code": "sn",
      "enName": "SENEGAL",
      "cnName": "塞内加尔",
      "dialingCode": "+221",
      "numberCode": "686",
      "showName": "塞内加尔(SENEGAL)"
    },
    {
      "code": "sc",
      "enName": "SEYCHELLES",
      "cnName": "塞舌尔",
      "dialingCode": "+248",
      "numberCode": "690",
      "showName": "塞舌尔(SEYCHELLES)"
    },
    {
      "code": "sl",
      "enName": "SIERRA LEONE",
      "cnName": "塞拉利昂",
      "dialingCode": "+232",
      "numberCode": "694",
      "showName": "塞拉利昂(SIERRA LEONE)"
    },
    {
      "code": "sg",
      "enName": "SINGAPORE",
      "cnName": "新加坡",
      "dialingCode": "+65",
      "numberCode": "702",
      "showName": "新加坡(SINGAPORE)"
    },
    {
      "code": "sk",
      "enName": "SLOVAKIA",
      "cnName": "斯洛伐克",
      "dialingCode": "+421",
      "numberCode": "703",
      "showName": "斯洛伐克(SLOVAKIA)"
    },
    {
      "code": "si",
      "enName": "SLOVENIA",
      "cnName": "斯洛文尼亚",
      "dialingCode": "+386",
      "numberCode": "705",
      "showName": "斯洛文尼亚(SLOVENIA)"
    },
    {
      "code": "sb",
      "enName": "SOLOMON ISLANDS",
      "cnName": "所罗门群岛",
      "dialingCode": "+677",
      "numberCode": "90",
      "showName": "所罗门群岛(SOLOMON ISLANDS)"
    },
    {
      "code": "so",
      "enName": "SOMALIA",
      "cnName": "索马里",
      "dialingCode": "+252",
      "numberCode": "706",
      "showName": "索马里(SOMALIA)"
    },
    {
      "code": "za",
      "enName": "SOUTH AFRICA",
      "cnName": "南非",
      "dialingCode": "+27",
      "numberCode": "710",
      "showName": "南非(SOUTH AFRICA)"
    },
    {
      "code": "es",
      "enName": "SPAIN",
      "cnName": "西班牙",
      "dialingCode": "+34",
      "numberCode": "724",
      "showName": "西班牙(SPAIN)"
    },
    {
      "code": "lk",
      "enName": "SRI LANKA",
      "cnName": "斯里兰卡",
      "dialingCode": "+94",
      "numberCode": "144",
      "showName": "斯里兰卡(SRI LANKA)"
    },
    {
      "code": "sd",
      "enName": "SUDAN",
      "cnName": "苏丹",
      "dialingCode": "+249",
      "numberCode": "736",
      "showName": "苏丹(SUDAN)"
    },
    {
      "code": "sr",
      "enName": "SURINAME",
      "cnName": "苏里南",
      "dialingCode": "+597",
      "numberCode": "740",
      "showName": "苏里南(SURINAME)"
    },
    {
      "code": "sz",
      "enName": "SWAZILAND",
      "cnName": "斯威士兰",
      "dialingCode": "+268",
      "numberCode": "748",
      "showName": "斯威士兰(SWAZILAND)"
    },
    {
      "code": "se",
      "enName": "SWEDEN",
      "cnName": "瑞典",
      "dialingCode": "+46",
      "numberCode": "752",
      "showName": "瑞典(SWEDEN)"
    },
    {
      "code": "ch",
      "enName": "SWITZERLAND",
      "cnName": "瑞士",
      "dialingCode": "+41",
      "numberCode": "756",
      "showName": "瑞士(SWITZERLAND)"
    },
    {
      "code": "sy",
      "enName": "SYRIAN ARAB REPUBLIC",
      "cnName": "叙利亚",
      "dialingCode": "+963",
      "numberCode": "760",
      "showName": "叙利亚(SYRIAN ARAB REPUBLIC)"
    },
    {
      "code": "tw",
      "enName": "TAIWAN, PROVINCE OF CHINA",
      "cnName": "台湾",
      "dialingCode": "+886",
      "numberCode": "158",
      "showName": "台湾(TAIWAN)"
    },
    {
      "code": "tj",
      "enName": "TAJIKISTAN",
      "cnName": "塔吉克斯坦",
      "dialingCode": "+992",
      "numberCode": "762",
      "showName": "塔吉克斯坦(TAJIKISTAN)"
    },
    {
      "code": "tz",
      "enName": "TANZANIA, UNITED REPUBLIC OF",
      "cnName": "坦桑尼亚",
      "dialingCode": "+255",
      "numberCode": "834",
      "showName": "坦桑尼亚(TANZANIA, UNITED REPUBLIC OF)"
    },
    {
      "code": "th",
      "enName": "THAILAND",
      "cnName": "泰国",
      "dialingCode": "+66",
      "numberCode": "764",
      "showName": "泰国(THAILAND)"
    },
    {
      "code": "tg",
      "enName": "TOGO",
      "cnName": "多哥",
      "dialingCode": "+228",
      "numberCode": "768",
      "showName": "多哥(TOGO)"
    },
    {
      "code": "to",
      "enName": "TONGA",
      "cnName": "汤加",
      "dialingCode": "+676",
      "numberCode": "776",
      "showName": "汤加(TONGA)"
    },
    {
      "code": "tt",
      "enName": "TRINIDAD AND TOBAGO",
      "cnName": "特立尼达和多巴哥",
      "dialingCode": "+1809",
      "numberCode": "780",
      "showName": "特立尼达和多巴哥(TRINIDAD AND TOBAGO)"
    },
    {
      "code": "tn",
      "enName": "TUNISIA",
      "cnName": "突尼斯",
      "dialingCode": "+216",
      "numberCode": "788",
      "showName": "突尼斯(TUNISIA)"
    },
    {
      "code": "tr",
      "enName": "TURKEY",
      "cnName": "土耳其",
      "dialingCode": "+90",
      "numberCode": "792",
      "showName": "土耳其(TURKEY)"
    },
    {
      "code": "tm",
      "enName": "TURKMENISTAN",
      "cnName": "土库曼斯坦",
      "dialingCode": "+993",
      "numberCode": "795",
      "showName": "土库曼斯坦(TURKMENISTAN)"
    },
    {
      "code": "ug",
      "enName": "UGANDA",
      "cnName": "乌干达",
      "dialingCode": "+256",
      "numberCode": "800",
      "showName": "乌干达(UGANDA)"
    },
    {
      "code": "ua",
      "enName": "UKRAINE",
      "cnName": "乌克兰",
      "dialingCode": "+380",
      "numberCode": "804",
      "showName": "乌克兰(UKRAINE)"
    },
    {
      "code": "ae",
      "enName": "UNITED ARAB EMIRATES",
      "cnName": "阿拉伯联合酋长国",
      "dialingCode": "+971",
      "numberCode": "784",
      "showName": "阿拉伯联合酋长国(UNITED ARAB EMIRATES)"
    },
    {
      "code": "gb",
      "enName": "UNITED KINGDOM",
      "cnName": "英国",
      "dialingCode": "+44",
      "numberCode": "826",
      "showName": "英国(UNITED KINGDOM)"
    },
    {
      "code": "us",
      "enName": "UNITED STATES",
      "cnName": "美国",
      "dialingCode": "+1",
      "numberCode": "840",
      "showName": "美国(UNITED STATES)"
    },
    {
      "code": "uy",
      "enName": "URUGUAY",
      "cnName": "乌拉圭",
      "dialingCode": "+598",
      "numberCode": "858",
      "showName": "乌拉圭(URUGUAY)"
    },
    {
      "code": "uz",
      "enName": "UZBEKISTAN",
      "cnName": "乌兹别克斯坦",
      "dialingCode": "+998",
      "numberCode": "860",
      "showName": "乌兹别克斯坦(UZBEKISTAN)"
    },
    {
      "code": "ve",
      "enName": "VENEZUELA, BOLIVARIAN REPUBLIC OF",
      "cnName": "委内瑞拉",
      "dialingCode": "+58",
      "numberCode": "862",
      "showName": "委内瑞拉(VENEZUELA, BOLIVARIAN REPUBLIC OF)"
    },
    {
      "code": "vn",
      "enName": "VIET NAM",
      "cnName": "越南",
      "dialingCode": "+84",
      "numberCode": "704",
      "showName": "越南(VIET NAM)"
    },
    {
      "code": "ye",
      "enName": "YEMEN",
      "cnName": "也门",
      "dialingCode": "+967",
      "numberCode": "887",
      "showName": "也门(YEMEN)"
    },
    {
      "code": "zm",
      "enName": "ZAMBIA",
      "cnName": "赞比亚",
      "dialingCode": "+260",
      "numberCode": "894",
      "showName": "赞比亚(ZAMBIA)"
    },
    {
      "code": "zw",
      "enName": "ZIMBABWE",
      "cnName": "津巴布韦",
      "dialingCode": "+263",
      "numberCode": "716",
      "showName": "津巴布韦(ZIMBABWE)"
    }
  ]
}